import React from "react";
import {
  instanceMetaData,
} from "../../redux/api/api.types";
import InstanceContactRow from "./InstanceContactRow";
import InstanceResellerTableRow from "./InstanceResellerTableRow";
import InstanceContactTable from "./InstanceContactTable";

export default function InstanceResellersDataTable (data: instanceMetaData) {
  const renderContactTable = ({resellers}: instanceMetaData) => {
    if (resellers) {
      return resellers.map((entry) => InstanceResellerTableRow(entry));
    }
    return InstanceContactRow({
      rowEmail: "-",
      rowFirst: "-",
      rowLast: "-"
    })
  };

  return (
    <InstanceContactTable
      title="Resellers"
      headers={
        InstanceContactRow({
          rowEmail: "Email",
          rowFirst: "First Name",
          rowLast: "Last Name"
        }, true)
      }
      tableData={renderContactTable(data)}
    />
  );
}